var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vtx-modal',{attrs:{"component":_vm.component,"payload":_vm.payload,"close-on-overlay-click":false},on:{"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }